import { useEffect, useState } from "react";
import {
  formatPhoneNumberToE164,
  formatPhoneNumberToHumanReadable,
} from "../utls/utils";
import Input, { InputProps } from "./input";

export type ThemedPhoneInputProps = Omit<InputProps, "value" | "onChange"> & {
  value?: string; // E.164 or raw digits
  onChange?: (value: string) => void; // emits E.164
};

export default function ThemedPhoneInput({
  value,
  onChange,
  ...props
}: ThemedPhoneInputProps) {
  const [display, setDisplay] = useState<string>("");

  useEffect(() => {
    setDisplay(formatPhoneNumberToHumanReadable(value || ""));
  }, [value]);

  return (
    <Input
      {...props}
      value={display}
      onChange={(e) => {
        const raw = e.target.value || "";
        // Normalize to digits for display formatting
        const digits = raw.replace(/\D/g, "").slice(0, 10);
        const human = formatPhoneNumberToHumanReadable(digits);
        setDisplay(human);
        onChange?.(formatPhoneNumberToE164(digits));
      }}
      inputMode="tel"
      placeholder={props.placeholder ?? "(555) 555-5555"}
    />
  );
}
